import { render } from "./CheckboxesPage.vue?vue&type=template&id=2b56a310&scoped=true"
import script from "./CheckboxesPage.vue?vue&type=script&lang=js"
export * from "./CheckboxesPage.vue?vue&type=script&lang=js"

import "./CheckboxesPage.vue?vue&type=style&index=0&id=2b56a310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b56a310"]])

export default __exports__